import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";

const VERSION = 0;

export async function updateAppName(appId: string, appName: string) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000
    };

    const result = await httpNetworking.simplePUTRequest(
        `${API_URL}/saas/${appId}`,
        { action: "name-update", newName: appName },
        options,
        VERSION
    );

    return result.data;
}

export async function getAppPricingDetails(appId: number) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000
    };

    const result = await httpNetworking.simpleGETRequest(`${API_URL}/saas/${appId}/pricing`, options, VERSION);
    return result.data;
}

export async function deleteSaasApp(appId: string) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };

    const result = await httpNetworking.simpleDELETERequest(`${API_URL}/saas/${appId}`, options, VERSION);

    return result.data;
}
